import { FunctionComponent, ReactNode } from 'react'

import styled, { css } from 'styled-components'

import { mobileCSS } from '@measures/responsive'
import useEnableEnhancedSearchPage from '@hooks/useEnableEnhancedSearchPage'

interface ResultsHeaderProps {
  children: ReactNode
}

interface StyledResultHeaderProps {
  isEnhancedSearchPage: boolean
}

const StyledResultHeader = styled.div<StyledResultHeaderProps>`
  ${({
    theme: {
      spacing: { spacing16, spacing32 },
      colors: { strokeWeak },
    },
    isEnhancedSearchPage,
  }) => css`
    display: flex;
    flex-direction: column;
    margin-bottom: ${spacing16};
    ${!isEnhancedSearchPage &&
    mobileCSS(css`
      margin-bottom: ${spacing32};
      border-bottom: 1px solid ${strokeWeak};
    `)}
  `}
`

const ResultsHeader: FunctionComponent<ResultsHeaderProps> = ({ children }) => {
  const isEnhancedSearchPage = useEnableEnhancedSearchPage()
  return (
    <StyledResultHeader isEnhancedSearchPage={isEnhancedSearchPage}>
      {children}
    </StyledResultHeader>
  )
}

export default ResultsHeader
